import { render } from "./Commercial.vue?vue&type=template&id=1597f6fe&ts=true"
import script from "./Commercial.vue?vue&type=script&lang=ts"
export * from "./Commercial.vue?vue&type=script&lang=ts"

import "./Commercial.vue?vue&type=style&index=0&id=1597f6fe&lang=scss"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\98\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__